"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateClaimsFromRequirementResultOutputDtoSchema = exports.citationClaimSchema = exports.generateClaimsFromRequirementResultInputDtoSchema = void 0;
const z = __importStar(require("zod"));
const generateClaimsFromRequirementResultInput = {
    resultId: z.string(),
};
exports.generateClaimsFromRequirementResultInputDtoSchema = z.object(generateClaimsFromRequirementResultInput);
exports.citationClaimSchema = z.object({
    fileId: z.string().describe('File that contains the evidence for the claim'),
    claim: z.string().describe('The claim that evidence should be cited for'),
    referenceDesignator: z.string().describe('The reference designator of the component the claim is about'),
});
const generateClaimsFromRequirementResultOutput = {
    claims: z.array(exports.citationClaimSchema),
};
exports.generateClaimsFromRequirementResultOutputDtoSchema = z.object(generateClaimsFromRequirementResultOutput);
//# sourceMappingURL=generate-claims-from-requirement-result.dto.js.map